/** Exec Custom Metrics audit (CONF-212, spec §4). Pure payload builders;
 *  the fail-closed writer is execPricingAudit.recordEscapeEvent, reused
 *  unchanged so an unlogged metric escape blocks the artifact exactly as an
 *  unlogged pricing escape does. CONF-258 retired the capacity-override kind
 *  entirely — every override is now a per-node throughput rating, so the
 *  unit is always canonical GB/s and there is no `kind` left to carry. */
import { metricDeltas, countMetricChanges } from '../domain/MetricsOverrides';

const changesOf = (execMetrics) =>
  metricDeltas(execMetrics.overrides).map((d) => ({
    key: d.key, label: d.label, unit: 'GB/s', baseline: d.baseline, custom: d.custom,
  }));

const commonPayload = ({ execMetrics, config, customerName, quoteName, actor, appVersion }) => ({
  actorEmail: actor?.email ?? null,
  actorSub: actor?.sub ?? null,
  quarter: config?.quarter ?? null,
  customerName: customerName ?? null,
  quoteName: quoteName ?? null,
  changeCount: countMetricChanges(execMetrics.overrides),
  changes: changesOf(execMetrics),
  appVersion: appVersion ?? null,
});

export function buildMetricsEscapeEvent(artifactType, ctx) {
  return {
    eventType: 'execMetricsEscape',
    artifactType,
    quoteSerial: ctx.quoteSerial ?? null,
    vendor: ctx.vendorId,
    payload: commonPayload(ctx),
  };
}

export function buildMetricsPersistEvent(ctx) {
  return {
    eventType: 'execMetricsPersist',
    artifactType: 'quoteSave',
    quoteSerial: ctx.quoteId ?? null,
    vendor: ctx.vendorId,
    payload: { ...commonPayload(ctx), savedAt: ctx.savedAt ?? null },
  };
}
